/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Event_Group_CreatedInputs */

const en_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new event group has been created using the selected marker list`)
};

const fr_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nouveau groupe d'evenements a ete cree a partir de la liste de marqueurs selectionnee`)
};

const de_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurde eine neue Ereignisgruppe anhand der ausgewählten Markerliste erstellt.`)
};

const it_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È stato creato un nuovo gruppo di eventi utilizzando l'elenco dei marcatori selezionati`)
};

const ru_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создана новая группа событий с использованием выбранного списка маркеров.`)
};

const es_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha creado un nuevo grupo de eventos utilizando la lista de marcadores seleccionada`)
};

const zh_cn2_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已使用选定的标记列表创建了一个新的事件组`)
};

const ja_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したマーカーリストを使用して新しいイベントグループが作成されました`)
};

const hi_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित मार्कर सूची का उपयोग करके एक नया इवेंट समूह बनाया गया है।`)
};

const pt_pt2_markers_event_group_created = /** @type {(inputs: Markers_Event_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um novo grupo de eventos foi criado usando a lista de marcadores selecionada.`)
};

/**
* | output |
* | --- |
* | "A new event group has been created using the selected marker list" |
*
* @param {Markers_Event_Group_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_event_group_created = /** @type {((inputs?: Markers_Event_Group_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Event_Group_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_event_group_created(inputs)
	if (locale === "de") return de_markers_event_group_created(inputs)
	if (locale === "it") return it_markers_event_group_created(inputs)
	if (locale === "ru") return ru_markers_event_group_created(inputs)
	if (locale === "es") return es_markers_event_group_created(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_event_group_created(inputs)
	if (locale === "ja") return ja_markers_event_group_created(inputs)
	if (locale === "hi") return hi_markers_event_group_created(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_event_group_created(inputs)
	return en_markers_event_group_created(inputs)
});